/**
 * Patrice Parisotto Design - Shopify Theme JavaScript
 */

(function() {
  'use strict';

  // ===== BACKGROUND IMAGE ROTATION =====
  function initBackgroundRotation() {
    if (!window.heroBackgrounds || window.heroBackgrounds.length === 0) {
      return;
    }

    const bgDiv = document.getElementById('bg');
    if (!bgDiv) return;

    // Create second background layer for dissolve effect
    const bgDiv2 = document.createElement('div');
    bgDiv2.id = 'bg2';
    bgDiv2.style.position = 'fixed';
    bgDiv2.style.top = '0';
    bgDiv2.style.left = '0';
    bgDiv2.style.right = '0';
    bgDiv2.style.bottom = '0';
    bgDiv2.style.backgroundSize = 'cover';
    bgDiv2.style.backgroundPosition = 'center center';
    bgDiv2.style.backgroundRepeat = 'no-repeat';
    bgDiv2.style.zIndex = '-1';
    bgDiv2.style.opacity = '0';
    bgDiv.parentNode.insertBefore(bgDiv2, bgDiv.nextSibling);

    let currImg = 0;
    const interval = window.heroRotationInterval || 4000;

    function changeImg() {
      // Only rotate on homepage and when window width > 960px
      const isHomepage = document.body.classList.contains('template-index');
      if (window.innerWidth > 960 && isHomepage) {
        // Get next image
        const nextImg = (currImg + 1) % window.heroBackgrounds.length;

        // Set next image on the hidden layer
        bgDiv2.style.backgroundImage = 'url(' + window.heroBackgrounds[nextImg] + ')';

        // Dissolve: fade out current, fade in next
        bgDiv.style.transition = 'opacity 2000ms ease-in-out';
        bgDiv2.style.transition = 'opacity 2000ms ease-in-out';
        bgDiv.style.opacity = '0';
        bgDiv2.style.opacity = '1';

        // After transition completes, swap the layers
        setTimeout(function() {
          bgDiv.style.backgroundImage = 'url(' + window.heroBackgrounds[nextImg] + ')';
          bgDiv.style.opacity = '1';
          bgDiv2.style.opacity = '0';
          bgDiv.style.transition = 'none';
          bgDiv2.style.transition = 'none';

          // Force reflow to apply the transition: none immediately
          void bgDiv.offsetWidth;

          currImg = nextImg;
        }, 2000);
      }
    }

    // Start rotation
    setInterval(changeImg, interval);
  }

  // ===== MOBILE MENU TOGGLE =====
  function initMobileMenu() {
    const menuBlock = document.getElementById('block-menu-block-3');
    if (!menuBlock) return;

    menuBlock.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent click-outside from immediately closing

      const wrapper = menuBlock.querySelector('.menu-block-wrapper') || menuBlock.querySelector('ul.menu');
      if (!wrapper) return;

      const isVisible = wrapper.style.display === 'block';
      wrapper.style.display = isVisible ? 'none' : 'block';

      // Close collections menu when hamburger opens
      const collectionsWrapper = document.querySelector('#block-collections-menu .collections-menu-wrapper');
      if (collectionsWrapper) {
        collectionsWrapper.style.display = 'none';
      }

      // Toggle header height on mobile
      const header = document.querySelector('.region-header');
      if (header && window.innerWidth <= 900) {
        header.classList.add('transitioning');
        // Set explicit state based on menu visibility
        if (isVisible) {
          header.classList.remove('open');
        } else {
          header.classList.add('open');
        }
      }
    });

    // Close hamburger menu when clicking outside
    document.addEventListener('click', function(e) {
      const menuWrapper = menuBlock.querySelector('.menu-block-wrapper') || menuBlock.querySelector('ul.menu');
      if (menuWrapper && !menuBlock.contains(e.target)) {
        const wasVisible = menuWrapper.style.display === 'block';
        if (wasVisible) {
          menuWrapper.style.display = 'none';
          // Close header if both menus are now closed
          const collectionsWrapper = document.querySelector('#block-collections-menu .collections-menu-wrapper');
          const collectionsVisible = collectionsWrapper && collectionsWrapper.style.display === 'block';
          if (!collectionsVisible) {
            const header = document.querySelector('.region-header');
            if (header) {
              header.classList.remove('open');
            }
          }
        }
      }
    });
  }

  // ===== MOBILE COLLECTIONS MENU TOGGLE =====
  function initMobileCollectionsMenu() {
    const collectionsBlock = document.getElementById('block-collections-menu');
    if (!collectionsBlock) return;

    collectionsBlock.addEventListener('click', function(e) {
      // Don't trigger if clicking on a link inside the menu
      if (e.target.tagName === 'A') return;

      e.stopPropagation(); // Prevent click-outside from immediately closing

      const wrapper = collectionsBlock.querySelector('.collections-menu-wrapper');
      if (!wrapper) return;

      const isVisible = wrapper.style.display === 'block';
      wrapper.style.display = isVisible ? 'none' : 'block';

      // Close hamburger menu when collections opens
      const menuWrapper = document.querySelector('#block-menu-block-3 .menu-block-wrapper');
      if (menuWrapper) {
        menuWrapper.style.display = 'none';
      }

      // Toggle header height on mobile
      const header = document.querySelector('.region-header');
      if (header && window.innerWidth <= 900) {
        header.classList.add('transitioning');
        // Set explicit state based on menu visibility
        if (isVisible) {
          header.classList.remove('open');
        } else {
          header.classList.add('open');
        }
      }
    });

    // Close collections menu when clicking outside
    document.addEventListener('click', function(e) {
      const wrapper = collectionsBlock.querySelector('.collections-menu-wrapper');
      if (wrapper && !collectionsBlock.contains(e.target)) {
        const wasVisible = wrapper.style.display === 'block';
        if (wasVisible) {
          wrapper.style.display = 'none';
          // Close header if both menus are now closed
          const menuWrapper = document.querySelector('#block-menu-block-3 .menu-block-wrapper');
          const menuVisible = menuWrapper && menuWrapper.style.display === 'block';
          if (!menuVisible) {
            const header = document.querySelector('.region-header');
            if (header) {
              header.classList.remove('open');
            }
          }
        }
      }
    });
  }

  // ===== SCROLL BEHAVIOR (HOMEPAGE) =====
  function initScrollBehavior() {
    if (!document.body.classList.contains('template-index')) {
      return;
    }

    const block5 = document.getElementById('block-block-5');
    const block9 = document.getElementById('block-block-9');
    const block10 = document.getElementById('block-block-10');
    const block4 = document.getElementById('block-block-4'); // Left circular button
    const block2 = document.getElementById('block-block-2'); // Right circular button
    const sidebarWrappers = document.querySelectorAll('.template-index .sidebars .region .wrapper');
    const sidebarRegions = document.querySelectorAll('.template-index .sidebars .region');
    const menuBlock = document.getElementById('block-views-collection-menu-block');

    let delay = false;

    function showCircularButtons() {
      // Hide hero elements by sliding up
      if (block5) {
        block5.style.marginTop = '-30%';
        block5.style.opacity = '0';
      }
      if (block10) {
        block10.style.bottom = '150%';
        block10.style.opacity = '0';
      }
      if (block9) {
        block9.style.opacity = '0';
      }

      // Show sidebar regions
      sidebarRegions.forEach(function(region) {
        region.classList.add('active');
      });

      // Show circular buttons
      if (block4) {
        block4.classList.add('show');
        setTimeout(function() {
          block4.style.opacity = '1';
        }, 100);
      }
      if (block2) {
        block2.classList.add('show');
        setTimeout(function() {
          block2.style.opacity = '1';
        }, 100);
      }

      // Move sidebar wrappers to visible position
      sidebarWrappers.forEach(function(wrapper) {
        wrapper.style.top = '30%';
      });
    }

    function hideCircularButtons() {
      // Show hero elements
      if (block5) {
        block5.style.marginTop = '';
        block5.style.opacity = '1';
      }
      if (block10) {
        block10.style.bottom = '';
        block10.style.opacity = '1';
      }
      if (block9) {
        block9.style.opacity = '1';
      }

      // Hide sidebar regions
      sidebarRegions.forEach(function(region) {
        region.classList.remove('active');
      });

      // Hide circular buttons
      if (block4) {
        block4.style.opacity = '0';
        setTimeout(function() {
          block4.classList.remove('show');
        }, 500);
      }
      if (block2) {
        block2.style.opacity = '0';
        setTimeout(function() {
          block2.classList.remove('show');
        }, 500);
      }

      // Reset sidebar wrappers
      sidebarWrappers.forEach(function(wrapper) {
        wrapper.style.top = '';
      });

      // Hide menu
      if (menuBlock) {
        menuBlock.style.display = 'none';
        menuBlock.style.opacity = '0';
      }
    }

    // Mouse wheel scroll handler
    function handleScroll(event) {
      if (delay) return;

      delay = true;
      setTimeout(function() {
        delay = false;
      }, 100);

      const delta = event.deltaY || event.detail || event.wheelDelta;

      if (delta < 0) {
        // Scroll up - return to intro view
        hideCircularButtons();
      } else {
        // Scroll down - show circular buttons
        showCircularButtons();
      }
    }

    // Click handlers for down arrow and hero text
    if (block9 || block5 || block10) {
      [block9, block5, block10].forEach(function(el) {
        if (el) {
          el.addEventListener('click', function() {
            showCircularButtons();
          });
        }
      });
    }

    // Attach scroll listeners
    window.addEventListener('wheel', handleScroll);
    window.addEventListener('mousewheel', handleScroll);
    window.addEventListener('DOMMouseScroll', handleScroll);

    // Note: Hover behavior for circular buttons is handled entirely by CSS
    // See .template-index .region-sidebar .wrapper:hover rules in styles.css
  }

  // ===== CATEGORY TOOLTIPS =====
  // Tooltips disabled - not needed for this design
  function initTooltips() {
    // Disabled
  }

  // ===== FLEXSLIDER CAROUSEL (PRODUCT PAGE) =====
  function initFlexslider() {
    const flexslider = document.querySelector('.flexslider-3panel');
    if (!flexslider) return;

    const imagesData = flexslider.querySelector('.flex-images-data');
    if (!imagesData) return;

    const images = Array.from(imagesData.querySelectorAll('img'));
    const totalImages = images.length;

    if (totalImages === 0) return;

    const track = flexslider.querySelector('.flex-image-track');
    const leftCell = flexslider.querySelector('.flex-cell-left');
    const rightCell = flexslider.querySelector('.flex-cell-right');
    const centerCell = flexslider.querySelector('.flex-cell-center');
    const arrowLeft = flexslider.querySelector('.flex-arrow-left');
    const arrowRight = flexslider.querySelector('.flex-arrow-right');

    let currentIndex = 0;
    let isAnimating = false;

    // Get center cell width based on viewport
    function getCenterWidth() {
      const viewportWidth = window.innerWidth;
      if (viewportWidth <= 800) {
        return 300;
      } else if (viewportWidth <= 1000) {
        return 350;
      } else if (viewportWidth <= 1200) {
        return 400;
      } else if (viewportWidth <= 1400) {
        return 450;
      } else {
        return 500;
      }
    }

    // Get side cell width
    function getSideWidth() {
      if (!centerCell) return 0;
      const wrapper = flexslider.querySelector('.flex-viewport-wrapper');
      const centerWidth = getCenterWidth();
      return (wrapper.offsetWidth - centerWidth) / 2;
    }

    // Check if we're in mobile mode
    function isMobile() {
      return window.innerWidth <= 900;
    }

    // Build the image track
    function buildTrack(skipAnimation) {
      // Mobile mode - show only current image centered
      if (isMobile()) {
        const wrapper = flexslider.querySelector('.flex-viewport-wrapper');
        const wrapperWidth = wrapper.offsetWidth;

        const imageIndex = ((currentIndex % totalImages) + totalImages) % totalImages;

        // If track is empty or skipping animation, create/replace image immediately
        if (track.children.length === 0 || skipAnimation) {
          track.innerHTML = '';
          const imageDiv = document.createElement('div');
          imageDiv.className = 'flex-track-image mobile-current';
          imageDiv.style.backgroundImage = 'url(' + images[imageIndex].src + ')';
          imageDiv.style.width = wrapperWidth + 'px';
          imageDiv.style.opacity = '1';
          track.appendChild(imageDiv);
        } else {
          // Crossfade to new image
          const currentImg = track.querySelector('.mobile-current');
          const newImg = document.createElement('div');
          newImg.className = 'flex-track-image mobile-next';
          newImg.style.backgroundImage = 'url(' + images[imageIndex].src + ')';
          newImg.style.width = wrapperWidth + 'px';
          newImg.style.opacity = '0';
          newImg.style.position = 'absolute';
          newImg.style.top = '0';
          newImg.style.left = '0';
          track.appendChild(newImg);

          // Trigger fade
          setTimeout(function() {
            if (currentImg) currentImg.style.opacity = '0';
            newImg.style.opacity = '1';

            // After transition, clean up
            setTimeout(function() {
              if (currentImg) currentImg.remove();
              newImg.classList.remove('mobile-next');
              newImg.classList.add('mobile-current');
              newImg.style.position = 'relative';
            }, 300);
          }, 50);
        }

        // Position track at 0
        track.style.transform = 'translateX(0)';
        return;
      }

      // Desktop mode - rebuild completely
      track.innerHTML = '';

      if (totalImages === 1) {
        // Single image - just show in center
        const centerWidth = getCenterWidth();
        const imageDiv = document.createElement('div');
        imageDiv.className = 'flex-track-image';
        imageDiv.style.backgroundImage = 'url(' + images[0].src + ')';
        imageDiv.style.width = centerWidth + 'px';
        track.appendChild(imageDiv);

        // Hide side cells
        if (leftCell) leftCell.style.display = 'none';
        if (rightCell) rightCell.style.display = 'none';

        // Position track in center
        track.style.transform = 'translateX(' + getSideWidth() + 'px)';
        return;
      }

      // Images must be wide enough to fill the widest cell (side cells)
      // This ensures each cell shows only ONE image
      const centerWidth = getCenterWidth();
      const sideWidth = getSideWidth();
      const imageWidth = Math.max(centerWidth, sideWidth);

      if (totalImages === 2) {
        // Two images - show center + left
        // Build track: [img1, img0, img1, img0]
        for (let i = 0; i < 4; i++) {
          const imageIndex = i % 2;
          const imageDiv = document.createElement('div');
          imageDiv.className = 'flex-track-image';
          imageDiv.style.backgroundImage = 'url(' + images[imageIndex].src + ')';
          imageDiv.style.width = imageWidth + 'px';
          imageDiv.setAttribute('data-index', i - 1);
          track.appendChild(imageDiv);
        }

        // Show only left and center cells
        if (leftCell) leftCell.style.display = 'block';
        if (rightCell) rightCell.style.display = 'none';
      } else {
        // 3+ images - show all three cells
        // Build track: [clone, clone, img0, img1, ..., imgN, clone, clone]
        const cloneCount = 2;

        for (let i = -cloneCount; i < totalImages + cloneCount; i++) {
          const imageIndex = ((i % totalImages) + totalImages) % totalImages;
          const imageDiv = document.createElement('div');
          imageDiv.className = 'flex-track-image';
          imageDiv.style.backgroundImage = 'url(' + images[imageIndex].src + ')';
          imageDiv.style.width = imageWidth + 'px';
          imageDiv.setAttribute('data-index', i);
          track.appendChild(imageDiv);
        }

        // Show all cells
        if (leftCell) leftCell.style.display = 'block';
        if (rightCell) rightCell.style.display = 'block';
      }

      // Position track so image 0 is in center
      positionTrack(false);
    }

    // Position the track based on currentIndex
    function positionTrack(animated) {
      const centerWidth = getCenterWidth();
      const sideWidth = getSideWidth();
      const imageWidth = Math.max(centerWidth, sideWidth);

      if (totalImages === 1) {
        track.style.transform = 'translateX(' + sideWidth + 'px)';
        return;
      }

      // Calculate offset
      // Track contains clones at the beginning
      // We want the image at currentIndex to align with the center cell (which starts at sideWidth)
      // All images are imageWidth, so we slide by imageWidth increments
      const cloneCount = totalImages === 2 ? 1 : 2;
      const offset = sideWidth - (cloneCount + currentIndex) * imageWidth;

      if (animated) {
        track.style.transition = 'transform 0.5s ease';
      } else {
        track.style.transition = 'none';
      }

      track.style.transform = 'translateX(' + offset + 'px)';
    }

    function slide(direction) {
      if (isAnimating || totalImages <= 1) return;
      isAnimating = true;

      if (direction === 'next') {
        currentIndex++;
      } else {
        currentIndex--;
      }

      // Mobile mode - rebuild track with new image
      if (isMobile()) {
        // Wrap index for mobile
        if (currentIndex >= totalImages) {
          currentIndex = 0;
        } else if (currentIndex < 0) {
          currentIndex = totalImages - 1;
        }
        buildTrack();
        isAnimating = false;
        return;
      }

      // Desktop mode - slide the track
      positionTrack(true);

      setTimeout(function() {
        // Check if we need to wrap around (non-mobile)
        if (currentIndex >= totalImages) {
          currentIndex = 0;
          positionTrack(false);
        } else if (currentIndex < 0) {
          currentIndex = totalImages - 1;
          positionTrack(false);
        }

        isAnimating = false;
      }, 500);
    }

    function updateArrowVisibility() {
      if (totalImages <= 1) {
        if (arrowLeft) arrowLeft.style.display = 'none';
        if (arrowRight) arrowRight.style.display = 'none';
      } else {
        if (arrowLeft) arrowLeft.style.display = 'block';
        if (arrowRight) arrowRight.style.display = 'block';
      }
    }

    // Attach click handlers
    if (arrowRight) {
      arrowRight.addEventListener('click', function(e) {
        e.preventDefault();
        slide('next');
      });
    }

    if (arrowLeft) {
      arrowLeft.addEventListener('click', function(e) {
        e.preventDefault();
        slide('prev');
      });
    }

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!document.body.classList.contains('template-product')) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        slide('prev');
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        slide('next');
      }
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        buildTrack(true); // Skip animation on resize
      }, 100);
    });

    // Initialize
    buildTrack(true); // Skip animation on initial load
    updateArrowVisibility();
  }

  // ===== CART BADGE UPDATE =====
  function updateHeaderCartCount(count) {
    const badge = document.querySelector('.cart-count-badge');
    if (!badge) return;

    badge.textContent = count;
    badge.setAttribute('data-cart-count', count);

    if (count > 0) {
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  // ===== CART AJAX FUNCTIONALITY =====
  function initCartAjax() {
    if (!document.body.classList.contains('template-cart')) {
      return;
    }

    // Helper function to show empty cart state
    function showEmptyCartState() {
      const cartReceipt = document.querySelector('.cart-receipt');
      const cartMain = document.querySelector('.cart-main');

      if (cartReceipt) {
        // Fade out the cart receipt
        cartReceipt.style.opacity = '0';
        cartReceipt.style.transition = 'opacity 0.3s ease';

        setTimeout(function() {
          cartReceipt.remove();

          // Create and show empty cart message
          const emptyDiv = document.createElement('div');
          emptyDiv.className = 'cart-empty-page';
          emptyDiv.innerHTML = '<p class="cart-empty-message">Your shopping cart is empty.</p>' +
            '<a href="/collections/all" class="button button--secondary">Continue Shopping</a>';

          if (cartMain) {
            cartMain.appendChild(emptyDiv);
          }
        }, 300);
      }
    }

    // Helper function to update cart UI
    function updateCartUI(cart) {
      // Update header cart badge count
      updateHeaderCartCount(cart ? cart.item_count : 0);

      // If cart is empty, show empty state without reloading
      if (!cart || cart.item_count === 0) {
        showEmptyCartState();
        return;
      }

      // Update cart totals
      const subtotalEl = document.getElementById('cart-subtotal');
      const totalEl = document.getElementById('cart-total');

      if (subtotalEl && totalEl) {
        // Format money using Shopify's money format
        const formatMoney = function(cents) {
          // Handle invalid/null values
          if (cents === null || cents === undefined || isNaN(cents)) {
            cents = 0;
          }

          const amount = (cents / 100).toFixed(2);
          const amountWithComma = amount.replace('.', ',');
          const amountNoDecimals = Math.floor(cents / 100).toString();

          // Use Shopify's money format if available
          if (window.shopifyMoneyFormat) {
            return window.shopifyMoneyFormat
              .replace('{{amount_with_comma_separator}}', amountWithComma)
              .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
              .replace('{{amount}}', amount)
              .replace('{{amount_no_decimals}}', amountNoDecimals);
          }

          // Fallback to Euro format
          return '€' + amountWithComma;
        };

        subtotalEl.textContent = formatMoney(cart.total_price);
        totalEl.textContent = formatMoney(cart.total_price);
      }
    }

    // Quantity change handler
    function handleQuantityChange(line, newQuantity) {
      const cartItem = document.querySelector('.cart-item[data-line="' + line + '"]');
      if (!cartItem) return;

      // Add loading state
      cartItem.classList.add('updating');

      // Update cart via AJAX
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: newQuantity
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        // Remove loading state
        cartItem.classList.remove('updating');

        if (newQuantity === 0) {
          // Remove the row with animation
          cartItem.style.opacity = '0';
          setTimeout(function() {
            cartItem.remove();
            updateCartUI(cart);
          }, 300);
        } else {
          // Update line item total
          const item = cart.items[line - 1];
          if (item) {
            const totalEl = cartItem.querySelector('.cart-item__total-price');
            if (totalEl) {
              const formatMoney = function(cents) {
                const amount = (cents / 100).toFixed(2);
                return '€' + amount;
              };
              totalEl.textContent = formatMoney(item.line_price);
            }
          }
          updateCartUI(cart);
        }
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
        cartItem.classList.remove('updating');
        alert('There was an error updating your cart. Please try again.');
      });
    }

    // Plus button handler
    const plusButtons = document.querySelectorAll('.quantity-button--plus');
    plusButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const line = parseInt(button.getAttribute('data-line'));
        const input = document.querySelector('.cart-item[data-line="' + line + '"] .quantity-input');
        if (input) {
          const newQty = parseInt(input.value) + 1;
          input.value = newQty;
          handleQuantityChange(line, newQty);
        }
      });
    });

    // Minus button handler
    const minusButtons = document.querySelectorAll('.quantity-button--minus');
    minusButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const line = parseInt(button.getAttribute('data-line'));
        const input = document.querySelector('.cart-item[data-line="' + line + '"] .quantity-input');
        if (input) {
          const currentQty = parseInt(input.value);
          if (currentQty > 1) {
            const newQty = currentQty - 1;
            input.value = newQty;
            handleQuantityChange(line, newQty);
          }
        }
      });
    });

    // Input change handler (direct typing)
    const quantityInputs = document.querySelectorAll('.quantity-input');
    quantityInputs.forEach(function(input) {
      let timeout;
      input.addEventListener('change', function() {
        const line = parseInt(input.getAttribute('data-line'));
        let newQty = parseInt(input.value);

        // Validate quantity
        if (isNaN(newQty) || newQty < 0) {
          newQty = 1;
          input.value = 1;
        }

        handleQuantityChange(line, newQty);
      });

      // Also handle typing with debounce
      input.addEventListener('input', function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          input.dispatchEvent(new Event('change'));
        }, 1000);
      });
    });

    // Remove button handler (for old table-style cart if still in use)
    const removeButtons = document.querySelectorAll('.cart-item__remove-button');
    removeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const line = parseInt(button.getAttribute('data-line'));

        // Remove without confirmation
        handleQuantityChange(line, 0);
      });
    });

    // Receipt-style cart remove buttons
    const receiptRemoveButtons = document.querySelectorAll('.receipt-item-remove');
    receiptRemoveButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const line = parseInt(button.getAttribute('data-line'));
        const variantId = button.getAttribute('data-variant-id');

        // Get cart item
        const cartItem = document.querySelector('.cart-receipt-item[data-line="' + line + '"]');

        // Add loading state
        if (cartItem) {
          cartItem.classList.add('updating');
        }

        // Remove item by setting quantity to 0 using variant ID (more stable than line number)
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 0
          })
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json().catch(function() {
            throw new Error('Invalid JSON response');
          });
        })
        .then(function(cart) {
          // Validate cart response
          if (!cart || typeof cart.item_count === 'undefined') {
            throw new Error('Invalid cart response');
          }

          // Remove item with animation
          if (cartItem) {
            cartItem.style.opacity = '0';
            setTimeout(function() {
              cartItem.remove();
              updateCartUI(cart);
            }, 300);
          } else {
            // If cartItem not found, just update UI
            updateCartUI(cart);
          }
        })
        .catch(function(error) {
          console.error('Cart update error:', error);
          if (cartItem) {
            cartItem.classList.remove('updating');
          }
          alert('There was an error removing this item. Please try again.');
        });
      });
    });
  }

  // ===== INFINITE SCROLL FOR COLLECTIONS =====
  function initInfiniteScroll() {
    const collectionGrid = document.getElementById('collection-grid');
    if (!collectionGrid) return;

    const productGrid = collectionGrid.querySelector('.collection-product-grid');
    const loadingIndicator = collectionGrid.querySelector('.infinite-scroll-loading');
    let isLoading = false;
    let hasMorePages = true;

    function getNextPageUrl() {
      return collectionGrid.getAttribute('data-next-url');
    }

    function setNextPageUrl(url) {
      if (url) {
        collectionGrid.setAttribute('data-next-url', url);
      } else {
        hasMorePages = false;
        collectionGrid.removeAttribute('data-next-url');
      }
    }

    function loadMoreProducts() {
      if (isLoading || !hasMorePages) return;

      const nextUrl = getNextPageUrl();
      if (!nextUrl) {
        hasMorePages = false;
        return;
      }

      isLoading = true;
      if (loadingIndicator) {
        loadingIndicator.style.display = 'block';
      }

      fetch(nextUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get new products
          const newProducts = doc.querySelectorAll('#collection-grid .collection-product-grid .views-row');

          // Append new products to grid
          newProducts.forEach(function(product) {
            productGrid.appendChild(product);
          });

          // Update next page URL
          const newNextUrl = doc.querySelector('#collection-grid').getAttribute('data-next-url');
          setNextPageUrl(newNextUrl);

          isLoading = false;
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
        })
        .catch(function(error) {
          console.error('Error loading more products:', error);
          isLoading = false;
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
        });
    }

    // Detect when user scrolls near bottom
    function checkScroll() {
      if (isLoading || !hasMorePages) return;

      const scrollPosition = window.scrollY + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const threshold = 800; // Load when 800px from bottom

      if (scrollPosition >= pageHeight - threshold) {
        loadMoreProducts();
      }
    }

    // Throttle scroll events
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(checkScroll, 100);
    });

    // Initial check in case content is short
    setTimeout(checkScroll, 500);
  }

  // ===== INITIALIZE ON DOM READY =====
  function init() {
    initBackgroundRotation();
    initMobileMenu();
    initMobileCollectionsMenu();
    initScrollBehavior();
    initTooltips();
    initFlexslider();
    initCartAjax();
    initInfiniteScroll();

    // Set homepage min-height
    const highlighted = document.querySelector('.template-index .region-highlighted');
    if (highlighted) {
      highlighted.style.minHeight = window.innerHeight + 'px';
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();